export const style = {
    mainWrapper: {py: 2, textAlign: "center"},
    phoneWrapper: {textAlign: 'center'},
    phoneText: {
        padding: '8px',
        backgroundColor: 'rgba(100, 100, 115, 0.1)',
        marginBottom: '8px'
    },
    body: {
        border: '1px solid rgba(100, 100, 115, 0.1)',
        minHeight: '130px',
        maxHeight: '200px',
        overflowY: 'scroll',
        marginTop: '2px',
        padding: '8px'
    },
    buttonWrapper: {marginTop: '25px'},
    button: {
        width: '100%',
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    },
    icon: {marginRight: '10px'}
}
